export default __webpack_public_path__ + "images/bc106dd7c37206383e5af97b03fb8aaa-language.webp";